module.exports = __webpack_public_path__ + "img/25-25-25-25.da7af20c.svg";